import { render, staticRenderFns } from "./BidsPopup.vue?vue&type=template&id=049f5f3b&scoped=true"
import script from "./BidsPopup.vue?vue&type=script&lang=js"
export * from "./BidsPopup.vue?vue&type=script&lang=js"
import style0 from "./BidsPopup.vue?vue&type=style&index=0&id=049f5f3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049f5f3b",
  null
  
)

export default component.exports